import { Tab, TabProps } from "@mui/material";
import React from "react";

const StyledTab: React.FC<TabProps> = ({ children, sx, ...props }) => (
  <Tab
    {...props}
    sx={{
      ...sx,
      ...{
        minHeight: "47px",
        paddingTop: "0",
        paddingBottom: "0",
        textTransform: "none",

        "& svg": {
          marginRight: "6px !important",
        },
      },
    }}
  >
    {children}
  </Tab>
);

export default StyledTab;